// سدر الخليج: مكوّنا سطر الشحن (sedr-shipping-line) وملخص السلة (sedr-cart-summary). وصفهما في رأس
// snippets/sedr-shipping-line.liquid. كانا مضمّنين في كل صفحة، ونُقلا إلى هذا الملف ليُخزَّن في المتصفح (STR-107).
(() => {
  if (window.customElements.get('sedr-shipping-line')) return;

  const TIMEOUT = 15000, POLL = 700, TTL = 30 * 60 * 1000, CHOICE = 'sedr-shipping-country', SUMMARY = 'sedr-cart-summary-open';

  // عنوان داخلي ثابت لكل دولة من دول الأسواق (STR-165): العاصمة أو مدينة يرجع لها سعر، ومعها المنطقة (باسمها أو رمزها) والرمز البريدي حيث
  // تشترطهما. جُرّبت كلها بطلب السعر يوم 12 أكتوبر 2026، وليس فيها 13 دولة لم يرجع لها سعر (sedr_unpriced في Liquid)
  const SEDR_ADDRESSES = {
    AE: { province: 'Dubai', city: 'Dubai' },
    KW: { province: 'Al Asimah', city: 'Kuwait City' },
    QA: { city: 'Doha' },
    OM: { city: 'Muscat' },
    BH: { city: 'Manama' },
    IS: { city: 'Reykjavik', zip: '101' },
    AZ: { city: 'Baku', zip: '1000' },
    AM: { city: 'Yerevan', zip: '0010' },
    AW: { city: 'Oranjestad' },
    AU: { province: 'ACT', city: 'Canberra', zip: '2600' },
    AF: { city: 'Kabul', zip: '1001' },
    AL: { city: 'Tirana', zip: '1001' },
    DE: { city: 'Berlin', zip: '10115' },
    AG: { city: 'St. John\'s' },
    AD: { city: 'Andorra la Vella', zip: 'AD100' },
    AO: { city: 'Luanda' },
    AI: { city: 'The Valley' },
    UY: { province: 'UY-MO', city: 'Montevideo', zip: '11000' },
    UZ: { city: 'Tashkent', zip: '100000' },
    UG: { city: 'Kampala' },
    IE: { province: 'D', city: 'Dublin', zip: 'D02 X285' },
    ET: { city: 'Addis Ababa', zip: '1000' },
    ER: { city: 'Asmara' },
    ES: { province: 'M', city: 'Madrid', zip: '28001' },
    EE: { city: 'Tallinn', zip: '10111' },
    SZ: { city: 'Mbabane', zip: 'H100' },
    ID: { province: 'JK', city: 'Jakarta', zip: '10110' },
    IT: { province: 'RM', city: 'Rome', zip: '00118' },
    JO: { city: 'Amman' },
    EC: { city: 'Quito', zip: '090105' },
    BR: { province: 'DF', city: 'Brasilia', zip: '70040-010' },
    PT: { province: 'PT-11', city: 'Lisbon', zip: '1000-001' },
    BA: { city: 'Sarajevo', zip: '71000' },
    CZ: { city: 'Prague', zip: '110 00' },
    ME: { city: 'Podgorica', zip: '81000' },
    DZ: { city: 'Algiers', zip: '16000' },
    DK: { city: 'Copenhagen', zip: '1050' },
    CV: { city: 'Praia', zip: '7600' },
    SV: { province: 'SV-SS', city: 'San Salvador', zip: '1101' },
    SN: { city: 'Dakar', zip: '12500' },
    SE: { city: 'Stockholm', zip: '111 20' },
    SO: { city: 'Mogadishu', zip: 'JH  09010' },
    CN: { province: 'BJ', city: 'Beijing', zip: '100000' },
    IQ: { city: 'Baghdad' },
    GA: { city: 'Libreville' },
    VA: { city: 'Vatican City' },
    PH: { province: 'PH-00', city: 'Manila', zip: '1000' },
    CM: { city: 'Yaounde' },
    CG: { city: 'Brazzaville' },
    CD: { city: 'Kinshasa' },
    MX: { province: 'DF', city: 'Mexico City', zip: '06000' },
    GB: { province: 'England', city: 'London', zip: 'SW1A 1AA' },
    NO: { city: 'Oslo', zip: '0150' },
    AT: { city: 'Vienna', zip: '1010' },
    NE: { city: 'Niamey', zip: '8001' },
    IN: { province: 'Delhi', city: 'New Delhi', zip: '110001' },
    US: { province: 'New York', city: 'New York', zip: '10001' },
    JP: { province: 'JP-13', city: 'Tokyo', zip: '100-0001' },
    GR: { city: 'Athens', zip: '105 57' },
    PG: { city: 'Port Moresby', zip: '111' },
    PY: { city: 'Asuncion', zip: '001015' },
    PK: { city: 'Karachi' },
    BB: { city: 'Bridgetown', zip: 'BB15028' },
    BM: { city: 'Hamilton', zip: 'FL 07' },
    BN: { city: 'Bandar Seri Begawan', zip: 'BS8811' },
    BE: { city: 'Brussels', zip: '1000' },
    BG: { city: 'Sofia', zip: '1000' },
    BZ: { city: 'Belmopan' },
    BD: { city: 'Dhaka', zip: '1000' },
    PA: { province: 'PA-8', city: 'Panama City' },
    BJ: { city: 'Porto-Novo' },
    BT: { city: 'Thimphu', zip: '11001' },
    BW: { city: 'Gaborone' },
    BF: { city: 'Ouagadougou', zip: '10010' },
    BI: { city: 'Gitega' },
    PL: { city: 'Warsaw', zip: '00-001' },
    BO: { city: 'La Paz' },
    PF: { city: 'Papeete', zip: '98709' },
    PE: { province: 'PE-LMA', city: 'Lima', zip: '15001' },
    TH: { province: 'TH-10', city: 'Bangkok', zip: '10200' },
    TW: { city: 'Taipei', zip: '100' },
    TM: { city: 'Ashgabat', zip: '744000' },
    TR: { city: 'Ankara', zip: '06420' },
    TT: { city: 'Port of Spain', zip: '120110' },
    TD: { city: 'N\'Djamena' },
    CL: { province: 'RM', city: 'Santiago', zip: '8320000' },
    TZ: { city: 'Dodoma', zip: '6090' },
    TG: { city: 'Lome' },
    TV: { city: 'Funafuti' },
    TN: { city: 'Tunis', zip: '1000' },
    TO: { city: 'Nuku\'alofa' },
    TL: { city: 'Dili' },
    JM: { city: 'Kingston' },
    AX: { city: 'Mariehamn', zip: '22150' },
    BS: { city: 'Nassau' },
    KM: { city: 'Moroni' },
    MQ: { city: 'Fort-de-France', zip: '97220' },
    MV: { city: 'Male', zip: '20026' },
    SB: { city: 'Honiara' },
    FO: { city: 'Torshavn', zip: '100' },
    FK: { city: 'Stanley' },
    VG: { city: 'Road Town', zip: 'VG1110' },
    KY: { city: 'George Town', zip: 'KY1-1100' },
    CK: { city: 'Avarua' },
    CC: { city: 'West Island' },
    WF: { city: 'Mata-Utu', zip: '98600' },
    CX: { city: 'Flying Fish Cove' },
    IM: { city: 'Douglas', zip: 'IM2 1AA' },
    NF: { city: 'Kingston' },
    CF: { city: 'Bangui' },
    DO: { city: 'Santo Domingo', zip: '11903' },
    ZA: { province: 'GP', city: 'Pretoria', zip: '0002' },
    SS: { city: 'Juba' },
    GE: { city: 'Tbilisi', zip: '0105' },
    DJ: { city: 'Djibouti' },
    JE: { city: 'Saint Helier', zip: 'JE1 1AA' },
    DM: { city: 'Roseau' },
    RW: { city: 'Kigali' },
    RO: { province: 'B', city: 'Bucharest', zip: '010011' },
    RE: { city: 'Saint-Denis', zip: '97400' },
    ZM: { city: 'Lusaka', zip: '50100' },
    ZW: { city: 'Harare' },
    CI: { city: 'Abidjan' },
    WS: { city: 'Apia', zip: 'WS1434' },
    BL: { city: 'Gustavia', zip: '97091' },
    MF: { city: 'Marigot', zip: '97150' },
    SM: { city: 'San Marino', zip: '47890' },
    VC: { city: 'Kingstown', zip: 'VC0100' },
    KN: { city: 'Basseterre', zip: 'KN0101' },
    LC: { city: 'Castries', zip: 'LC05  201' },
    SX: { city: 'Philipsburg' },
    SH: { city: 'Jamestown' },
    ST: { city: 'Sao Tome' },
    LK: { city: 'Colombo', zip: '00100' },
    SJ: { city: 'Longyearbyen', zip: '9170' },
    SK: { city: 'Bratislava', zip: '811 01' },
    SI: { city: 'Ljubljana', zip: '1000' },
    SG: { city: 'Singapore', zip: '018956' },
    SR: { city: 'Paramaribo' },
    CH: { city: 'Bern', zip: '3003' },
    SL: { city: 'Freetown' },
    SC: { city: 'Victoria' },
    RS: { city: 'Belgrade', zip: '11000' },
    TJ: { city: 'Dushanbe', zip: '734000' },
    GM: { city: 'Banjul' },
    GH: { city: 'Accra', zip: 'GA-120-9182' },
    GD: { city: 'St. George\'s' },
    GL: { city: 'Nuuk', zip: '3911' },
    GT: { province: 'GUA', city: 'Guatemala City', zip: '01001' },
    GP: { city: 'Basse-Terre', zip: '97100' },
    GF: { city: 'Cayenne', zip: '97300' },
    GY: { city: 'Georgetown' },
    GG: { city: 'St Peter Port', zip: 'GY1 1AA' },
    GN: { city: 'Conakry', zip: '011' },
    GQ: { city: 'Malabo' },
    GW: { city: 'Bissau', zip: '1000' },
    VU: { city: 'Port Vila' },
    FR: { city: 'Paris', zip: '75001' },
    VE: { province: 'VE-A', city: 'Caracas', zip: '1010' },
    FI: { city: 'Helsinki', zip: '00100' },
    VN: { city: 'Hanoi', zip: '100000' },
    FJ: { city: 'Suva' },
    CY: { city: 'Nicosia', zip: '1010' },
    KG: { city: 'Bishkek', zip: '720001' },
    KZ: { city: 'Astana', zip: '010000' },
    NC: { city: 'Noumea', zip: '98814' },
    HR: { city: 'Zagreb', zip: '10000' },
    KH: { city: 'Phnom Penh', zip: '12000' },
    CA: { province: 'ON', city: 'Ottawa', zip: 'K1A 0B1' },
    CW: { city: 'Willemstad' },
    KR: { province: 'KR-11', city: 'Seoul', zip: '04524' },
    CR: { province: 'CR-SJ', city: 'San Jose', zip: '10101' },
    XK: { city: 'Pristina', zip: '10000' },
    CO: { province: 'DC', city: 'Bogota', zip: '110111' },
    KI: { city: 'Tarawa' },
    KE: { city: 'Nairobi', zip: '00100' },
    LA: { city: 'Vientiane', zip: '01000' },
    LB: { city: 'Beirut' },
    LU: { city: 'Luxembourg', zip: '1009' },
    LY: { city: 'Tripoli' },
    LR: { city: 'Monrovia', zip: '1000' },
    LT: { city: 'Vilnius', zip: '01100' },
    LI: { city: 'Vaduz', zip: '9496' },
    LS: { city: 'Maseru', zip: '100' },
    MT: { city: 'Valletta', zip: 'VLT 1117' },
    ML: { city: 'Bamako' },
    MY: { province: 'KUL', city: 'Kuala Lumpur', zip: '50000' },
    YT: { city: 'Mamoudzou', zip: '97600' },
    MG: { city: 'Antananarivo', zip: '501' },
    MK: { city: 'Skopje', zip: '1000' },
    MW: { city: 'Lilongwe', zip: '207201' },
    MO: { city: 'Macau' },
    MN: { city: 'Ulaanbaatar', zip: '14200' },
    MR: { city: 'Nouakchott' },
    MU: { city: 'Port Louis', zip: '11106' },
    MZ: { city: 'Maputo', zip: '1102' },
    MD: { city: 'Chisinau', zip: 'MD-2001' },
    MC: { city: 'Monaco', zip: '98000' },
    MS: { city: 'Brades', zip: 'MSR1210' },
    NA: { city: 'Windhoek', zip: '10005' },
    NP: { city: 'Kathmandu', zip: '44600' },
    NG: { province: 'FC', city: 'Abuja', zip: '900001' },
    NI: { city: 'Managua', zip: '52000' },
    NZ: { province: 'WGN', city: 'Wellington', zip: '6011' },
    NU: { city: 'Alofi' },
    HT: { city: 'Port-au-Prince', zip: 'HT6120' },
    HN: { city: 'Tegucigalpa', zip: '31301' },
    HU: { city: 'Budapest', zip: '1051' },
    NL: { city: 'Amsterdam', zip: '1012 JS' },
    BQ: { city: 'Kralendijk' },
    HK: { province: 'HK', city: 'Hong Kong' },
    AR: { province: 'B', city: 'La Plata', zip: '1900' },
    LV: { city: 'Riga', zip: '1050' },
    MM: { city: 'Yangon', zip: '11181' },
    TC: { city: 'Providenciales', zip: 'TKCA 1ZZ' }
  };

  // البحث يطبّع العربية كمنتقي الدولة في الرأس (STR-83): التشكيل والهمزات والتاء المربوطة والألف المقصورة و«ال»
  const normalize = (text) =>
    String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[ً-ٰٟـ]/g, '')
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/(^|\s)ال(?=\S)/g, '$1')
      .replace(/[()\-–,.]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const ALIASES = {
    SA: 'ksa saudi السعوديه',
    AE: 'uae emirates dubai امارات دبي',
    KW: 'kuwait',
    QA: 'qatar',
    BH: 'bahrain',
    OM: 'oman',
    JO: 'jordan',
    IQ: 'iraq',
    LB: 'lebanon',
    CY: 'cyprus',
    PK: 'pakistan',
    IN: 'india',
    US: 'usa america امريكا',
    GB: 'uk britain england بريطانيا انجلترا انكلترا لندن',
    DE: 'germany deutschland',
    NL: 'holland هولندا',
    TR: 'turkey turkiye',
    KR: 'south korea كوريا الجنوبيه',
    CN: 'china',
    FR: 'france',
    CA: 'canada',
    AU: 'australia'
  };

  // ما يُرسل مع الدولة إلى صفحة الدفع غير اسمها (STR-118): ما لا تقبلها دونه، فلا يظهر للعميل عنوان لم يكتبه إلا ما لا بد منه
  const CHECKOUT_FIELDS = {};
  Object.entries({
    province: 'AE KW AU UY IE ES ID IT BR PT SV CN PH MX IN US JP PA PE TH CL ZA RO GT VE CA KR CR CO MY NG HK AR',
    zip: 'IS AU DE AD IE ES EE ID IT BR PT BA CZ ME DK SE CN PH MX GB NO AT IN US JP GR BM BN BE BG PL PF TH AX MQ FO VG WF IM ZA GE JE RE BL MF SM SJ SK SI SG CH RS GL GP GF GG FR FI CY NC HR CA KR LU LT LI MT MY YT MG MK MC MS NZ HU NL AR LV'
  }).forEach(([field, countries]) => countries.split(' ').forEach((country) => (CHECKOUT_FIELDS[country] = CHECKOUT_FIELDS[country] || []).push(field)));

  // آخر دولة اختارها العميل، وطلبات صفحة الدفع متتابعة فلا يسبق قديمُها جديدَها
  let wanted, sending = Promise.resolve();
  const toCheckout = (country) => {
    const address = SEDR_ADDRESSES[country] || {}, params = new URLSearchParams(), root = window.Shopify?.routes?.root || '/';
    params.append('shipping_address[country]', country);
    (CHECKOUT_FIELDS[country] || []).forEach((field) => params.append(`shipping_address[${field}]`, address[field]));
    sending = sending.then(() => fetch(`${root}cart/prepare_shipping_rates.json?${params}`, { method: 'POST', keepalive: true })).catch(() => {});
  };

  const pending = new Map();
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const storage = {
    get(key) {
      try { return sessionStorage.getItem(key); } catch (error) { return null; }
    },
    set(key, value) {
      try { sessionStorage.setItem(key, value); } catch (error) {}
    }
  };

  const readCache = (key) => {
    try {
      const entry = JSON.parse(storage.get(key));
      return entry && Date.now() - entry.t < TTL ? entry.rates : undefined;
    } catch (error) {
      return undefined;
    }
  };

  // خيارات تطبيقات الشحن من الأرخص، أو [] إن لم يُرجع شيء، أو undefined إن انقضت المهلة أو تعذّر الطلب
  const fetchRates = async (query) => {
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), TIMEOUT);
    const root = window.Shopify?.routes?.root || '/', signal = controller.signal;

    try {
      const prepare = await fetch(`${root}cart/prepare_shipping_rates.json?${query}`, { method: 'POST', signal });

      if (prepare.status === 422) return [];
      if (!prepare.ok) return undefined;

      while (!signal.aborted) {
        await wait(POLL);
        const response = await fetch(`${root}cart/async_shipping_rates.json?${query}`, { signal });
        if (response.status === 422) return [];
        if (!response.ok) return undefined;

        const data = await response.json();
        if (!data) continue;

        return (data.shipping_rates || [])
          .filter((rate) => rate.source && rate.source !== 'shopify' && rate.name?.trim() !== 'الشحن')
          .map((rate) => ({
            name: (rate.presentment_name || rate.name).trim(),
            source: rate.source,
            price: parseFloat(rate.price),
            currency: rate.currency
          }))
          .filter((rate) => rate.price > 0)
          .sort((a, b) => a.price - b.price);
      }

      return undefined;
    } finally {
      clearTimeout(timer);
    }
  };

  class SedrShippingLine extends HTMLElement {
    // أثناء تحميل الصفحة يتصل المكوّن قبل أن يُقرأ ما بداخله، فينتظر اكتمالها
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.isConnected && this._init(), { once: true });
      } else {
        this._init();
      }
    }

    // النافذة تنتقل إلى body عند فتحها في الجوال، فتُحفظ القائمة بمرجعها لا بموضعها
    _init() {
      this.result = this.querySelector('[data-result]');
      this.listbox = this.querySelector('x-listbox');
      this.country = this.getAttribute('country') || '';

      if (this.listbox) {
        this._fill();
        const saved = storage.get(CHOICE);
        if (saved && this._option(saved)) this._choose(saved);

        this._onSelect = (event) => {
          wanted = event.detail.value;
          storage.set(CHOICE, event.detail.value);
          this._choose(event.detail.value);
          this._update(true);
        };
        this.listbox.addEventListener('listbox:select', this._onSelect);
        this._setupSearch();
      }

      // القالب يحدّث قائمة السلة بعد أسفلها، فيصل شريط الشحن المجاني بحالة دولة المتجر بعد المقدّر: يُضبط كلما رُسم (STR-99)
      this._barObserver?.disconnect();
      this._barObserver = new MutationObserver((records) => {
        const added = records.some((record) => Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches('free-shipping-bar') || node.querySelector('free-shipping-bar'))));
        if (added) this._freeBar();
      });
      this._barObserver.observe(this.closest('.shopify-section') || document.body, { childList: true, subtree: true });

      this._update();
    }

    disconnectedCallback() {
      this.listbox?.removeEventListener('listbox:select', this._onSelect);
      this._barObserver?.disconnect();
    }

    // يكمل القائمة بدول الأسواق كلها من قائمة الرأس (sedr-country-options) وبترتيبها (STR-165). وإن كان x-listbox قد
    // عمل قبلها فهو لا يربط الخيارات الجديدة، فتُربط كما يربطها القالب: معرّف لكل خيار، والنقر يحدده ويطلق listbox:select
    _fill() {
      const source = document.getElementById('sedr-country-options');
      if (!source) return;

      const drawn = new Map(Array.from(this.listbox.querySelectorAll('[role="option"]')).map((option) => [option.value, option]));
      const bind = this.listbox.getAttribute('role') === 'listbox', base = source.dataset.flagBase || '', options = [];

      source.content.querySelectorAll('[role="option"]').forEach((item) => {
        if (item.value !== 'SA' && !SEDR_ADDRESSES[item.value]) return;
        let option = drawn.get(item.value);

        if (!option) {
          option = item.cloneNode(true);
          option.className = 'popover-listbox__option';
          option.setAttribute('aria-selected', 'false');
          const flag = option.querySelector('img[data-flag]');
          if (flag && base) flag.src = `${base}${flag.dataset.flag}.svg`;

          if (bind) {
            option.id = 'option-' + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e9));
            option.addEventListener('click', () => {
              this.listbox.setAttribute('aria-activedescendant', option.id);
              option.dispatchEvent(new CustomEvent('listbox:select', { bubbles: true, detail: { value: option.value } }));
            });
          }
        }

        drawn.delete(item.value);
        options.push(option);
      });

      if (options.length) this.listbox.replaceChildren(...options, ...drawn.values());
    }

    _setupSearch() {
      this.search = this.querySelector('.sedr-shipping-popover__search');
      this.empty = this.querySelector('.sedr-shipping-popover__empty');
      if (!this.search) return;

      this.options = Array.from(this.listbox.querySelectorAll('[role="option"]'));
      this.index = this.options.map((option) => normalize(`${option.textContent} ${option.value} ${ALIASES[option.value] || ''}`));

      this.search.addEventListener('input', () => this._filter());

      // Enter يختار الدولة إن بقيت واحدة، والسهم ينزل إلى القائمة
      this.search.addEventListener('keydown', (event) => {
        const visible = this.options.filter((option) => !option.hidden);
        if (event.key === 'ArrowDown' && visible.length) {
          event.preventDefault();
          visible[0].focus();
        } else if (event.key === 'Enter') {
          event.preventDefault();
          if (visible.length === 1) visible[0].click();
          else visible[0]?.focus();
        }
      });

      // يحل محل أسهم القالب حتى لا تقف على دولة مخفية
      this.listbox.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const visible = this.options.filter((option) => !option.hidden), current = visible.indexOf(document.activeElement);
        event.preventDefault();
        event.stopPropagation();
        if (event.key === 'ArrowDown') visible[Math.min(current + 1, visible.length - 1)]?.focus();
        else if (current <= 0) this.search.focus();
        else visible[current - 1].focus();
      }, true);

      // تُعاد القائمة كاملة عند إغلاق النافذة
      this.listbox.closest('x-popover')?.addEventListener('dialog:after-hide', () => {
        if (!this.search.value) return;
        this.search.value = '';
        this._filter();
      });
    }

    _filter() {
      // «ال» وحدها بداية أغلب الأسماء العربية: لا تُصفّى بها القائمة
      const query = normalize(this.search.value).replace(/^ال$/, '');
      let count = 0;
      this.options.forEach((option, i) => {
        option.hidden = !!query && !this.index[i].includes(query);
        if (!option.hidden) count++;
      });
      if (this.empty) this.empty.textContent = count ? '' : this.empty.dataset.emptyText;
    }

    // ملخص التقدير في زر النافذة التي فيها المكوّن، أو اسم الزر إن لم يكن تقدير. والشحن المجاني يُعلَّم مكتملًا
    _summary(text, done = false) {
      const id = this._brief && this.closest('[data-sedr-panel]')?.id;
      if (!id) return;
      document.querySelectorAll(`[aria-controls="${id}"] [data-summary]`).forEach((label) => {
        if (label.dataset.label === undefined) label.dataset.label = label.textContent;
        label.textContent = text || label.dataset.label;
        label.closest('[aria-controls]')?.toggleAttribute('data-done', done);
      });
    }

    // الإجمالي مع الشحن تحت «الإجمالي» في القسم نفسه (STR-87): داخل المملكة من القالب، وخارجها بأقل سعر ومعه سطر
    // الجمارك، ونص القالب إن لم يكن سعر أو اختلفت عملته عن عملة السلة
    _total(rates, pending = false) {
      const box = (this.closest('.shopify-section') || document).querySelector('[data-sedr-total]');
      if (box?.hasAttribute('data-summary')) return this._summaryTotal(box, rates, pending);
      const row = box?.querySelector('[data-row]'), tax = box?.querySelector('[data-tax]'), customs = box?.querySelector('[data-customs]');
      if (!row || !tax) return;

      const country = this.country, currency = this.getAttribute('currency'), rate = rates?.[0], d = box.dataset;
      let label = '', value = '';

      if (country === 'SA' && currency === 'SAR') {
        [label, value] = [d.saLabel, d.saValue];
      } else if (country && country !== 'SA' && rate && !(rate.currency && rate.currency !== currency)) {
        label = d.label;
        value = (rates.length > 1 ? d.from : '') + this._money(Number(this.getAttribute('total')) / 100 + rate.price);
      }

      row.hidden = !value;
      row.querySelector('[data-label]').textContent = label;
      row.querySelector('[data-value]').textContent = value;

      // نص القالب من Liquid (فيه رابط سياسة الشحن بالإنجليزية) حتى يصل سعر، ثم «شامل الضريبة» وحدها
      if (value) tax.textContent = d.prefix;
      else tax.innerHTML = d.fallback;

      if (customs) {
        customs.hidden = !country || country === 'SA';
        customs.textContent = (tax.textContent.trim() ? d.join : '') + d.customs;
      }
    }

    // الإجمالي صفًّا واحدًا في الدرج (STR-115): داخل المملكة الإجمالي مع رسوم الشحن، وخارجها «الإجمالي التقديري» بأقل سعر،
    // وإلا الإجمالي وحده وسطر الشحن «جارٍ الحساب» حتى يصل سعر أو «يُحسب عند الدفع». وسطر الجمارك ظاهر خارج المملكة
    _summaryTotal(box, rates, pending) {
      const country = this.country, currency = this.getAttribute('currency'), rate = rates?.[0], d = box.dataset;
      const label = box.querySelector('[data-label]'), value = box.querySelector('[data-value]'), ship = box.querySelector('[data-ship]');
      const customs = box.querySelector('[data-customs]');
      if (!label || !value || !ship) return;

      let texts = [d.baseLabel, d.baseValue, country && country !== 'SA' && pending ? d.shipPending : d.shipUnknown];

      if (country === 'SA' && currency === 'SAR') {
        texts = [d.saLabel, d.saValue, d.saShip];
      } else if (country && country !== 'SA' && rate && !(rate.currency && rate.currency !== currency)) {
        const from = rates.length > 1 ? d.from : '';
        texts = [d.label, from + this._money(Number(this.getAttribute('total')) / 100 + rate.price), from + this._money(rate.price)];
      }

      [label.textContent, value.textContent, ship.textContent] = texts;
      if (customs) customs.hidden = !country || country === 'SA';
    }

    // شريط الشحن المجاني للمملكة وحدها (STR-99): يتبع دولة التقدير لا دولة المتجر، وبلا دولة يبقى كما رسمه القالب
    _freeBar() {
      if (!this.country) return;
      (this.closest('.shopify-section') || document).querySelectorAll('free-shipping-bar').forEach((bar) => {
        bar.hidden = this.country !== 'SA';
      });
    }

    // بصيغة المتجر كإجمالي السلة (money_with_currency)، وبغير الريال بصيغة العملة
    _money(amount) {
      const currency = this.getAttribute('currency'), format = window.themeVariables?.settings?.moneyWithCurrencyFormat;
      const value = amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (currency === 'SAR' && /\{\{\s*amount\s*\}\}/.test(format || '')) return format.replace(/\{\{\s*amount\s*\}\}/, value);
      return new Intl.NumberFormat('en', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    }

    _short(rate) {
      const format = window.themeVariables?.settings?.moneyFormat;
      if ((rate.currency || this.getAttribute('currency')) !== 'SAR' || !format) return this._price(rate);
      return format.replace(/\{\{\s*\w+\s*\}\}/, Math.round(rate.price));
    }

    _option(value) {
      return Array.from(this.listbox.querySelectorAll('[role="option"]')).find((option) => option.value === value);
    }

    // يحدّث الزر (العلم والاسم) والخيار المحدد في القائمة
    _choose(value) {
      const option = this._option(value), flag = this.querySelector('[data-flag]'), name = this.querySelector('[data-name]');
      if (!option) return;

      this.country = value;
      this.listbox.querySelectorAll('[role="option"]').forEach((item) => item.setAttribute('aria-selected', String(item === option)));
      if (flag) {
        flag.src = `${flag.dataset.base}${value.toLowerCase()}.svg`;
        flag.hidden = false;
      }
      if (name) name.textContent = option.textContent.trim();
    }

    // chosen: اختارها العميل الآن، فتُرسل إلى صفحة الدفع ولو لم يُطلب تقدير
    async _update(chosen = false) {
      const country = this.country;
      const token = (this._token = {});

      this._summary('');
      this._total(undefined, true);
      this._freeBar();
      if (!country) return this._text('');
      if (country === 'SA') {
        if (chosen) toCheckout(country);
        this._summary(this.getAttribute('sa-summary'), this.hasAttribute('sa-free'));
      }
      if (country === 'SA') return this._brief ? this._line(this.getAttribute('sa-text'), this._en ? ' Delivery in 3–5 days.' : '، والتوصيل خلال 3–5 أيام') : this._text(this.getAttribute('sa-text'));

      const address = SEDR_ADDRESSES[country];
      if (!address) return this._text('');

      const params = new URLSearchParams();
      params.append('shipping_address[country]', country);
      ['province', 'city', 'zip'].forEach((field) => {
        if (address[field]) params.append(`shipping_address[${field}]`, address[field]);
      });

      const query = params.toString();
      const key = `sedr-shipping-v3:${query}:${this.getAttribute('weight')}:${this.getAttribute('total')}`;
      let rates = readCache(key);
      if (rates !== undefined && chosen) toCheckout(country);

      if (rates === undefined) {
        // آخر تقدير للدولة نفسها يبقى ظاهرًا حتى يصل سعر السلة الجديدة، فلا يرجع الزر إلى «الشحن» بعد كل إضافة
        const last = readCache(`sedr-shipping-last:${query}`);
        if (last && last.length) this._renderRates(last);
        else this._text(this._en ? 'Calculating shipping…' : 'جارٍ حساب سعر الشحن…');

        if (!pending.has(key)) {
          pending.set(key, fetchRates(query).catch(() => undefined).then((found) => {
            if (found !== undefined) storage.set(key, JSON.stringify({ rates: found, t: Date.now() }));
            pending.delete(key);
            // التقدير يترك في صفحة الدفع عنوانه الداخلي كاملًا، فيُستبدل به الأقل
            toCheckout(wanted || country);
            return found;
          }));
        }

        rates = await pending.get(key);
        if (token !== this._token || !this.isConnected) return;
      }

      if (rates !== undefined) storage.set(`sedr-shipping-last:${query}`, JSON.stringify({ rates, t: Date.now() }));
      this._renderRates(rates);
    }

    get _en() {
      return this.hasAttribute('en');
    }

    get _brief() {
      return this.hasAttribute('brief');
    }

    // في المساحة: السعر ومدة التوصيل في سطر واحد
    _line(...parts) {
      const line = document.createElement('p');
      line.append(...parts);
      this.result.replaceChildren(line);
      return line;
    }

    _text(text) {
      const paragraph = document.createElement('p');
      paragraph.className = 'text-subdued';
      paragraph.textContent = text || '';
      this.result.replaceChildren(...(text ? [paragraph] : []));
    }

    _price(rate) {
      const amount = Math.round(rate.price), currency = rate.currency || this.getAttribute('currency');

      if (currency !== 'SAR') {
        return new Intl.NumberFormat('en', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
      }

      if (this._en) return `SAR ${amount}`;

      const rest = amount % 100;
      return `${amount} ${rest >= 3 && rest <= 10 ? 'ريالات' : amount <= 2 || rest <= 2 ? 'ريال' : 'ريالًا'}`;
    }

    // حيث يظهر في صفحة الدفع مع الدولة غيرُ اسمها (STR-118)
    _confirm() {
      if (!CHECKOUT_FIELDS[this.country]) return '';
      return this._en ? ' Please check your full address at checkout.' : '. وتأكّد من عنوانك كاملًا في صفحة الدفع';
    }

    _renderRates(rates) {
      this._total(rates);
      if (!rates || !rates.length) {
        this._summary('');
        return this._text((this._en ? 'You will see the shipping cost at checkout.' : 'ستجد سعر الشحن في صفحة الدفع') + this._confirm());
      }

      // أقل سعر وحده، والخيارات مرتبة من الأرخص؛ الناقل يُختار في صفحة الدفع
      const line = document.createElement('p'), price = document.createElement('span');
      const several = rates.length > 1;

      price.className = 'bold';
      price.textContent = this._price(rates[0]);

      if (this._en) {
        line.append(several ? 'Shipping starts at ' : 'Shipping: ', price, this._brief ? '.' : '. The final cost appears at checkout.');
      } else {
        line.append(several ? 'أسعار الشحن تبدأ من ' : 'سعر الشحن ', price, this._brief ? '' : '، ويظهر السعر النهائي في صفحة الدفع');
      }

      const note = document.createElement('p');
      note.className = 'text-subdued';
      note.textContent = (this._en ? 'Delivery in 5–14 days.' : 'التوصيل خلال 5–14 يومًا') + this._confirm();

      if (!this._brief) return this.result.replaceChildren(line, note);

      // في المساحة: المدة في سطر السعر، ثم أنه تقدير، وملخصه في زرها
      const hint = document.createElement('p');
      hint.className = 'text-subdued text-xs';
      hint.textContent = (this._en ? 'Estimated shipping cost; the final price appears at checkout.' : 'سعر تقديري لتكلفة الشحن، والسعر النهائي يظهر عند إتمام الطلب') + this._confirm();
      line.append(this._en ? ' Delivery in 5–14 days.' : '، والتوصيل خلال 5–14 يومًا');
      this.result.replaceChildren(line, hint);
      this._summary(`${this._en ? 'From' : 'من'} ${this._short(rates[0])}`);
    }
  }

  window.customElements.define('sedr-shipping-line', SedrShippingLine);

  // صف الإجمالي في الدرج (STR-115) يبقى مفتوحًا إن فتحه العميل، فالدرج يعيد رسمه بعد كل تغيير في السلة. ويتصل قبل
  // أن يُرقّى details بداخله، فتكفي السمة؛ وإن كان مرقّى ضُبطت حالته معها دون حركة. وأثناء تحميل الصفحة ينتظر اكتمالها
  class SedrCartSummary extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.isConnected && this._init(), { once: true });
      } else {
        this._init();
      }
    }

    _init() {
      const details = this.querySelector('details');
      if (!details || this._ready) return;
      this._ready = true;

      if (storage.get(SUMMARY) === '1' && !details.hasAttribute('open')) {
        details.setAttribute('open', '');
        if ('_open' in details) details._open = true;
      }

      details.addEventListener('toggle', () => storage.set(SUMMARY, details.hasAttribute('open') ? '1' : '0'));
    }
  }

  window.customElements.define('sedr-cart-summary', SedrCartSummary);
})();
